import type { IDMMF, IDMMFEnum, IDMMFModel } from "@prisma/studio-common";

export type RuntimeModel = Omit<IDMMFModel, "name">;
export type RuntimeEnum = Omit<IDMMFEnum, "name">;

export type RuntimeDataModel = {
  readonly models: Record<string, RuntimeModel>;
  readonly enums: Record<string, RuntimeEnum>;
  readonly types: Record<string, RuntimeModel>;
};

export function dmmfToRuntimeDataModel(
  dmmfDataModel: IDMMF["datamodel"]
): RuntimeDataModel {
  return {
    models: buildMapForRuntime(dmmfDataModel.models),
    enums: buildMapForRuntime(dmmfDataModel.enums),
    types: buildMapForRuntime(dmmfDataModel.types),
  };
}

function buildMapForRuntime<T extends { name: string }>(
  list: T[]
): Record<string, Omit<T, "name">> {
  const result: Record<string, Omit<T, "name">> = {};
  for (const { name, ...rest } of list) {
    result[name] = rest;
  }
  return result;
}
